export default function CopyrightFooter({
  align = "left",
  onOpenTnC
}: {
  align: "left" | "right" | "center",
  onOpenTnC?: () => void
}) {
  const currentYear = new Date().getFullYear();

  return (
    <span className="d-block text-muted small" style={{ textAlign: align }}>
      Copyright © {currentYear} Singapore Institute of Technology. All Rights Reserved.
      {onOpenTnC && (
        <>
          {" "}
          <a className="tnc-footer-link link-grey" href="#" onClick={(e) => { e.preventDefault(); onOpenTnC(); }}>Terms and Conditions</a>.
        </>
      )}
    </span>
  );
}
